export const PARTS_DIAGRAM_IMAGE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20250203-12cd6-c89fd',
  alt: 'Parts Diagram'
};
export const PART_DIAGRAM_LIST_LIMIT_DESKTOP = 4;
export const PART_DIAGRAM_LIST_LIMIT_MOBILE = 3;
export const MAINTENANCE_REPAIR_LIMIT_DESKTOP = 6;
export const MAINTENANCE_REPAIR_LIMIT_MOBILE = 3;
export const KIT_TYPE_PMKIT = 'pmkit';
export const KIT_TYPE_SSRO = 'SSRO';
export const FORMATTED_DEFAULT_VALUE = '--';

export const QUICK_ACTIONS_SCHEMA = {
  SHOP_PARTS: 'SHOP_PARTS',
  CAT_PARTS_DIAGRAM: 'CAT_PARTS_DIAGRAM',
  REQUEST_SERVICE: 'REQUEST_SERVICE',
  ALP_MAINTENANCE_REPAIRS: 'ALP_MAINTENANCE_REPAIRS',
  MANUALS_AND_RESOURCES: 'MANUALS_AND_RESOURCES',
  MORE: 'MORE'
};

export const PAGE_BREAKPOINTS = {
  XL: 1200,
  LG: 960,
  MD: 768
};

export const CATEGORIES_PREVIEW_COUNT_TABLET = 6;
export const CATEGORIES_PREVIEW_COUNT_MOBILE = 4;

export const CATEGORY_URL = 'category';
export const categoriesListMock = [
  {
    name: 'Ground Engaging Tools',
    identifier: 'GROUND-ENGAGING-TOOLS',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-52df1-a867e',
    seoURL: '/en/wagnerequipment/get',
    seoUrlKeyword: 'get'
  },
  {
    name: 'Drivetrain',
    identifier: 'DRIVE-TRAIN',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-1b650-344b7',
    seoURL: '/en/wagnerequipment/drive-train',
    seoUrlKeyword: 'get'
  },
  {
    name: 'Electrical & Electronics',
    identifier: 'ELECTRICAL-ELECTRONICS',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-9e2f8-c8c38',
    seoURL: '/en/wagnerequipment/electrical-electronics',
    seoUrlKeyword: 'get'
  },
  {
    name: 'Hydralics',
    identifier: 'HYDRAULIC',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-7f918-c44be',
    seoURL: '/en/wagnerequipment/hydralics',
    seoUrlKeyword: 'get'
  }
];

export const filteredCategoriesMock = [
  {
    name: 'Drivetrain',
    identifier: 'DRIVE-TRAIN',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-1b650-344b7',
    seoURL: '/en/wagnerequipment/drive-train',
    seoUrlKeyword: 'get'
  },
  {
    name: 'Electrical & Electronics',
    identifier: 'ELECTRICAL-ELECTRONICS',
    imageURL:
      'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240424-9e2f8-c8c38',
    seoURL: '/en/wagnerequipment/electrical-electronics',
    seoUrlKeyword: 'get'
  }
];

export const notRelatedCategorisMock =
  'MACHINE-ATTACHMENTS|CAB|GROUND-ENGAGING-TOOLS|HYDRAULIC|STRUCTURES-OTH-SYS-COMPONENTS|UC';

export const EQUIPMENT_GROUP_ET = 'ET';

export const PARTS_DIAGRAM_SYSTEM = 'partsDiagramSystem';

export const KITS_PREVIEW_COUNT_DESKTOP = 10;

export const KITS_PREVIEW_COUNT_MOBILE = 5;

export const NO_PM_KITS_IMAGE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20241113-a1121-3a358',
  alt: 'No-Kits-Image'
};

export const SERVICE_RECOMMENDATION_STATE = {
  NEW_STATE: 'new',
  SEEN_STATE: 'seen'
};

export const NO_CVA_IMAGE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240717-fd8a9-97514',
  alt: 'No Customer Value Agreements Available'
};

export const CVA_LEARN_MORE_URL =
  'https://www.cat.com/{0}/support/maintenance/customer-value-agreements.html';

export const CVA_DEFAULT_LOCALE = 'en_US';

export const CVA_SPECIFIC_SUPPORTED_LANGUAGES = [
  'ar_SA',
  'de_DE',
  'en_AU',
  'en_GB',
  'en_ID',
  'en_IN',
  'en_MX',
  'en_US',
  'en_ZA',
  'es_ES',
  'es_MX',
  'es_US',
  'fr_DZ',
  'fr_FR',
  'fr_US',
  'id_ID',
  'it_IT',
  'ja_JP',
  'ko_KR',
  'nl_NL',
  'pl_PL',
  'pt_BR',
  'ru_RU',
  'sv_SE',
  'tr_TR',
  'zh_CN',
  'zh_TW',
  'zh_ZA'
];

export const CATSAS_ALP_DIY_VIDEOS_ESPOT = 'CATSAS_ALP_DIY_VIDEOS_ESPOT';

export const PRIMARY_GA_EVENT_CTA = 'e_primaryCTA';

export const ADDTOCART_GAEVENTS = {
  PRIMARY_CTA: PRIMARY_GA_EVENT_CTA,
  CONTEXT: 'Add to cart bestsellers section',
  BUTTON_EVENT_NAME: 'Add to Cart'
};

export const CONTACT_DEALER_GAEVENTS = {
  PRIMARY_CTA: PRIMARY_GA_EVENT_CTA,
  CONTEXT: 'Contact Dealer bestsellers section',
  BUTTON_EVENT_NAME: 'View all Parts'
};

export const VIEWREPLACEMENT_GAEVENTS = {
  PRIMARY_CTA: PRIMARY_GA_EVENT_CTA,
  CONTEXT: 'request information bestsellers section',
  BUTTON_EVENT_NAME: 'Request Information'
};
export const BEST_SELLERS_VIEW_ITEM_LIST = {
  item_list_id: 'PCC ALP TOP SELLING PARTS CATEGORY',
  item_list_name: 'PCC ALP TOP SELLING PARTS CATEGORY'
};

export const CONTACTUS_GAEVENTS = {
  gaprimaryCTA: PRIMARY_GA_EVENT_CTA,
  gaEventContext: 'Contact Us ALP Section',
  gaBtnEventName: 'Contact us'
};

export const SELECTSTOREALP_GAEVENTS = {
  selectStoreCTA: {
    gaprimaryCTA: PRIMARY_GA_EVENT_CTA,
    gaBtnEventName: 'Select Store',
    gaEventContext: 'Select Your Dealer ALP Section'
  },
  LaterCTA: {
    gaprimaryCTA: PRIMARY_GA_EVENT_CTA,
    gaBtnEventName: 'Later',
    gaEventContext: 'Select Your Dealer ALP Section'
  }
};
export const BEST_SELLERS_GA_EVENT = {
  addToCartCTA: {
    gaprimaryCTA: ADDTOCART_GAEVENTS.PRIMARY_CTA,
    gaBtnEventName: ADDTOCART_GAEVENTS.BUTTON_EVENT_NAME,
    gaEventContext: ADDTOCART_GAEVENTS.CONTEXT
  },
  contactDealerCTA: {
    gaprimaryCTA: CONTACT_DEALER_GAEVENTS.PRIMARY_CTA,
    gaBtnEventName: CONTACT_DEALER_GAEVENTS.BUTTON_EVENT_NAME,
    gaEventContext: CONTACT_DEALER_GAEVENTS.CONTEXT
  },
  viewReplacementCTA: {
    gaprimaryCTA: VIEWREPLACEMENT_GAEVENTS.PRIMARY_CTA,
    gaBtnEventName: VIEWREPLACEMENT_GAEVENTS.BUTTON_EVENT_NAME,
    gaEventContext: VIEWREPLACEMENT_GAEVENTS.CONTEXT
  },
  listNameAndId: 'PCC ALP TOP SELLING PARTS CATEGORY',
  gaEventFormLocation: 'PCC ALP TOP SELLING PARTS CATEGORY'
};

export const CUSTOMER_VALUE_AGREEMENTS_GA = {
  contentName: 'customer value agreements',
  contentType: 'content',
  contentLocation: 'body'
};

export const LEARN_MORE_GA = {
  dataEvent: 'e_primaryCTA',
  dataAttributeText: 'customer value agreeements section',
  dataAttributeContext: 'learn more'
};

export const OMM_BOOK_META = {
  sampleImageUrl: 'SampleImageUrl',
  pattern: /(https:\/\/.*\/)/gm
};

export const MANUALS_RESOURCES_LIST_LIMIT = 6;
export const MANUALS_RESOURCES_LIST_LIMIT_MOBILE = 3;

export const ALP_CANONICAL_URL =
  'https://parts.cat.com/{lang}/{esite}/equipment/{partName}/{partNumber}';

export const MAINTENANCE_REPAIR_CANONICAL_URL = `${ALP_CANONICAL_URL}/maintenance-and-repairs`;

export const IMAGE_PROPS = {
  loading: 'lazy' as const,
  format: 'webp' as const
};

export const VISION_LINK_ICON_PROPS = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20250703-ae39b-86617',
  width: 56,
  height: 50,
  ...IMAGE_PROPS
};

export const VISION_LINK_LOGO_PROPS = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240515-9ddec-732da',
  width: 72,
  height: 11,
  ...IMAGE_PROPS
};

export const TRADEMARK_ICON_PROPS = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20250703-b13dd-ccf0b',
  width: 5,
  height: 5,
  ...IMAGE_PROPS
};

export const PARTS_DIAGRAM_CANONICAL_URL = `${ALP_CANONICAL_URL}/parts-diagram`;

export const MANUALS_AND_RESOURCES_CANONICAL_URL = `${ALP_CANONICAL_URL}/manuals-and-resources`;

export const VISION_LINK = 'https://vl.cat.com';

export const VISION_LINK_URL = `${VISION_LINK}/assets/asset-details?assetId={0}&assetCustomerPartyNumber={1}&activeTab=OVERVIEW`;

export const UNIT_TRANSLATION = {
  h: 'hrs'
};

export const DATE_FORMAT_MM_DD_YYYY = 'MM/dd/yyyy';
export const SUBSCRIPTION_STATUS = {
  NOT_SUBSCRIBED: 'NOT_SUBSCRIBED',
  SUBSCRIBED: 'SUBSCRIBED'
};

export const WARRANTY_REGISTRATION_URL =
  'https://www.cat.com/{0}/support/maintenance/engine-warranty-registration.html?serialNumber={1}&salesModel={2}';

export const DEFAULT_WARRANTY_LANGUAGE = 'en_US';

export const WARRANTY_SUPPORTED_LANGUAGES = [
  'en_GB',
  'de_DE',
  'fr_FR',
  'it_IT',
  'pl_PL',
  'es_ES',
  'nl_NL',
  'sv_SE',
  'en_US',
  'fr_US',
  'es_US',
  'en_MX',
  'pt_BR',
  'es_MX',
  'en_ID',
  'id_ID',
  'en_AU',
  'ja_JP',
  'en_IN',
  'ko_KR',
  'zh_TW',
  'en_ZA',
  'fr_DZ',
  'zh_ZA',
  'ar_SA'
];

export const MISMATCHED_WARRANTY_LANGUAGES = {
  ar_EG: 'ar_SA',
  in_ID: 'id_ID'
};

export const WARRANTY_REGISTRATION_GAEVENTS = {
  DATA_TRACK_EVENT: PRIMARY_GA_EVENT_CTA,
  BUTTON_EVENT_NAME: 'register now',
  CONTEXT: 'register now from take action register and warranty section'
};

export const OMM_DATA_TRACK = {
  EVENT: 'e_primaryCTA',
  ATTR_NLTEXT: 'View All',
  ATTR_CONTEXT: 'Operations and maintenance manuals section'
};

export const VL_SUPPORTED_LANGUAGES = [
  'en_US',
  'de_DE',
  'es_ES',
  'fr_FR',
  'ru_RU',
  'nl_NL',
  'id_ID',
  'it_IT',
  'ja_JP',
  'ko_KR',
  'pl_PL',
  'pt_BR',
  'zh_CN',
  'sv_SE',
  'zh_TW',
  'tr_TR'
];

export const VL_DEFAULT_LOCALE = 'en-US';

export const VL_LEARN_MORE_URL = 'https://vl.cat.com/{0}';

export const VISION_LINK_TEXT = {
  MODEL: {
    TITLE: 'ALP_HEALTH_INSIGHTS_MODEL_TITLE',
    DESCRIPTION: 'ALP_HEALTH_INSIGHTS_MODEL_DESCRIPTION'
  },
  MARKETING: {
    TITLE: 'ALP_VISIONLINK_MARKETING_TITLE',
    DESCRIPTION: 'ALP_VISIONLINK_MARKETING_DESCRIPTION'
  }
};

export const matchUrl: string[] = ['/service-recommendations/'];

export const SERVICE_RECOMMENDATIONS_CANONICAL_URL = `${ALP_CANONICAL_URL}/service-recommendations`;

export const SHOP_PARTS_CANONICAL_URL = `${ALP_CANONICAL_URL}/shop-parts`;

// Remove <script> and <style> tags along with their content, and all other HTML tags
export const REMOVE_HTML_TAG_REGEX =
  /<script[^>]*>[\s\S]*?<\/script>|<style[^>]*>[\s\S]*?<\/style>|<[^<>]*>/gi;

export const SERVICE_RECOMMENDATION_GA = {
  gaprimaryCTA: PRIMARY_GA_EVENT_CTA,
  gaFacetNav: 'e_facetNav',
  gaBtnEventName: 'View all',
  gaEventCommonContext: 'service recommendations take action section'
};

export const MAX_AUTOSAVE_EQUIPMENT = 1000;
